import { render } from "./sf-description.vue?vue&type=template&id=6bd5ff4c"
import script from "./sf-description.vue?vue&type=script&lang=js"
export * from "./sf-description.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__